/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: k4MoYHGY6d3NVAoA3aDDg2
// Component: 0si8oZstPWru

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { V0ChatPanel } from "@/components/V0ChatPanel"; // plasmic-import: WdpXfwTW1MFB/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: k4MoYHGY6d3NVAoA3aDDg2/styleTokensProvider


import sty from "./PlasmicAiChat.module.css"; // plasmic-import: 0si8oZstPWru/css

import Icon6Icon from "./icons/PlasmicIcon__Icon6"; // plasmic-import: 7WUbyAl0QQLm/icon

createPlasmicElementProxy;

export type PlasmicAiChat__VariantMembers = {};
export type PlasmicAiChat__VariantsArgs = {};
type VariantPropType = keyof PlasmicAiChat__VariantsArgs;
export const PlasmicAiChat__VariantProps = new Array<VariantPropType>();

export type PlasmicAiChat__ArgsType = {};
type ArgPropType = keyof PlasmicAiChat__ArgsType;
export const PlasmicAiChat__ArgProps = new Array<ArgPropType>();

export type PlasmicAiChat__OverridesType = {
  root?: Flex__<"div">;
  svg?: Flex__<"svg">;
  freeBox?: Flex__<"div">;
  v0ChatPanel?: Flex__<typeof V0ChatPanel>;
};

export interface DefaultAiChatProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicAiChat__RenderFunc(props: {
  variants: PlasmicAiChat__VariantsArgs;
  args: PlasmicAiChat__ArgsType;
  overrides: PlasmicAiChat__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "toggled",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_k4MoYHGY6d3NVAoA3aDDg2",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      style={{ pointerEvents: "auto" }}
    >
      <Icon6Icon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames("all", sty.svg)}
        onClick={async event => {
          const $steps = {};

          $steps["updateToggled"] = true
            ? (() => {
                const actionArgs = {
                  variable: {
                    objRoot: $state,
                    variablePath: ["toggled"]
                  },
                  operation: 4
                };
                return (({ variable, value, startIndex, deleteCount }) => {
                  if (!variable) {
                    return;
                  }
                  const { objRoot, variablePath } = variable;

                  const oldValue = $stateGet(objRoot, variablePath);
                  $stateSet(objRoot, variablePath, !oldValue);
                  return !oldValue;
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["updateToggled"] != null &&
            typeof $steps["updateToggled"] === "object" &&
            typeof $steps["updateToggled"].then === "function"
          ) {
            $steps["updateToggled"] = await $steps["updateToggled"];
          }
        }}
        role={"img"}
      />

      {(() => {
        try {
          return $state.toggled;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames("all", sty.freeBox)}
        >
          <V0ChatPanel
            data-plasmic-name={"v0ChatPanel"}
            data-plasmic-override={overrides.v0ChatPanel}
            className={classNames("__wab_instance", sty.v0ChatPanel)}
            height={"600px"}
            width={"100%"}
          />
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg", "freeBox", "v0ChatPanel"],
  svg: ["svg"],
  freeBox: ["freeBox", "v0ChatPanel"],
  v0ChatPanel: ["v0ChatPanel"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
  freeBox: "div";
  v0ChatPanel: typeof V0ChatPanel;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAiChat__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAiChat__VariantsArgs;
    args?: PlasmicAiChat__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicAiChat__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicAiChat__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAiChat__ArgProps,
          internalVariantPropNames: PlasmicAiChat__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAiChat__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAiChat";
  } else {
    func.displayName = `PlasmicAiChat.${nodeName}`;
  }
  return func;
}

export const PlasmicAiChat = Object.assign(
  // Top-level PlasmicAiChat renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    freeBox: makeNodeComponent("freeBox"),
    v0ChatPanel: makeNodeComponent("v0ChatPanel"),

    // Metadata about props expected for PlasmicAiChat
    internalVariantProps: PlasmicAiChat__VariantProps,
    internalArgProps: PlasmicAiChat__ArgProps
  }
);

export default PlasmicAiChat;
/* prettier-ignore-end */
